"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKXSuiProvider = void 0;
const universal_provider_1 = require("@okxconnect/universal-provider");
const transactions_1 = require("@mysten/sui/transactions");
const utils_1 = require("@mysten/sui/utils");
const client_1 = require("@mysten/sui/client");
class OKXSuiProvider {
    get defaultNetwork() {
        let network = this.provider.requestDefaultChainWithNamespace(universal_provider_1.NameSpaceKeySui);
        return network;
    }
    get suiClient() {
        var _a;
        let rpcUrl = (0, client_1.getFullnodeUrl)(this.defaultNetwork);
        let suiProvider = (_a = this.provider.session) === null || _a === void 0 ? void 0 : _a.namespaces[universal_provider_1.NameSpaceKeySui];
        if (suiProvider && suiProvider.rpcMap) {
            let url = suiProvider.rpcMap[this.currentChainId];
            if (url !== undefined) {
                // @ts-ignore
                rpcUrl = url;
                console.log("use custom rpc======> ", rpcUrl);
            }
            else {
                console.log("use mainnet rpc======> ", rpcUrl);
            }
        }
        else {
            console.log("use mainnet rpc======> ", rpcUrl);
        }
        return new client_1.SuiClient({ url: rpcUrl });
    }
    get currentChainId() {
        return `sui:${this.defaultNetwork}`;
    }
    constructor(provider) {
        this.provider = provider;
    }
    getAccount() {
        var _a, _b, _c, _d, _e, _f, _g;
        let namespaces = universal_provider_1.NameSpaceKeySui;
        let account = (_b = (_a = this.provider.session) === null || _a === void 0 ? void 0 : _a.namespaces[namespaces]) === null || _b === void 0 ? void 0 : _b.accounts[0];
        console.log('====> getAccount');
        console.log(account);
        if (!account) {
            return undefined;
        }
        const accountArray = account.split(':');
        const address = account.split(':')[2];
        console.log("sui_publicKey", (_d = (_c = this.provider.session) === null || _c === void 0 ? void 0 : _c.namespaces[namespaces]) === null || _d === void 0 ? void 0 : _d.extra);
        let extra = (_g = (_f = (_e = this.provider.session) === null || _e === void 0 ? void 0 : _e.namespaces[namespaces]) === null || _f === void 0 ? void 0 : _f.extra) === null || _g === void 0 ? void 0 : _g[(`${accountArray[0]}:${accountArray[1]}`)];
        let publicKey = "";
        if (extra != undefined) {
            publicKey = extra["publicKey"];
            console.log("sui_publicKey", publicKey);
        }
        if (!address) {
            return undefined;
        }
        return {
            address: address,
            publicKey: publicKey
        };
    }
    signTransaction(input) {
        return __awaiter(this, void 0, void 0, function* () {
            const [txBytes, txSerialize] = yield this.generateTsBytesAndSerizlize(input);
            const ret = yield this.provider.request({
                method: "sui_signTransactionBlock",
                params: {
                    txBytes: txBytes,
                    txSerialize: txSerialize
                }
            }, this.currentChainId);
            if ("result" in ret) {
                return {
                    signature: ret.result,
                    transactionBlockBytes: txBytes,
                };
            }
            else {
                let errorData = ret;
                return errorData.error;
            }
        });
    }
    signAndExecuteTransaction(input) {
        return __awaiter(this, void 0, void 0, function* () {
            const [txBytes, txSerialize] = yield this.generateTsBytesAndSerizlize(input);
            let ret = (yield this.provider.request({
                method: "sui_signAndExecuteTransactionBlock",
                params: {
                    txBytes: txBytes,
                    txSerialize: txSerialize,
                },
            }, this.currentChainId));
            if ("result" in ret) {
                return {
                    confirmedLocalExecution: false,
                    digest: ret.result,
                    txBytes: txBytes,
                };
            }
            else {
                let errorData = ret;
                return errorData.error;
            }
        });
    }
    // input = {message: uint8Array }
    signMessage(input) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("====> signMessage:");
            console.log(input);
            const decoder = new TextDecoder("utf8");
            const b64encoded = btoa(decoder.decode(input.message));
            const message = atob(b64encoded);
            const ret = (yield this.provider.request({
                method: "sui_signMessage",
                params: {
                    message: message,
                },
            }, this.currentChainId));
            if ("result" in ret) {
                let successData = ret;
                console.log("====> signAction result");
                console.log(ret);
                const sign = successData.result;
                return {
                    messageBytes: b64encoded,
                    signature: sign,
                };
            }
            else {
                console.log("====> signAction result error");
                let errorData = ret;
                return errorData.error;
            }
        });
    }
    // input = {message: uint8Array }
    signPersonalMessage(input) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("====> signPersonalMessage：");
            console.log(input);
            const decoder = new TextDecoder("utf8");
            const b64encoded = btoa(decoder.decode(input.message));
            const message = atob(b64encoded);
            const ret = (yield this.provider.request({
                method: "sui_signPersonalMessage",
                params: {
                    message: message,
                },
            }, this.currentChainId));
            if ("result" in ret) {
                let successData = ret;
                console.log("====> signAction result");
                console.log(ret);
                const sign = successData.result;
                return {
                    bytes: b64encoded,
                    signature: sign,
                };
            }
            else {
                console.log("====> signAction result error");
                let errorData = ret;
                return errorData.error;
            }
        });
    }
    /// generate txBytes and txSerialize
    generateTsBytesAndSerizlize(input) {
        return __awaiter(this, void 0, void 0, function* () {
            /// txBytes and txSerialize may be constructed in advance by the dapp side
            let resultTuple = ["", ""];
            if ("txBytes" in input &&
                input.txBytes.length > 0 &&
                "txSerialize" in input &&
                input.txSerialize.length > 0) {
                resultTuple = [input.txBytes, input.txSerialize];
            }
            /// Otherwise, a transactionBlock parameter is required.
            if (!("transactionBlock" in input)) {
                throw new universal_provider_1.OKXConnectError(universal_provider_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `params doesn't contains transactionBlock`);
            }
            let senderAccounts = this.provider.requestAccountsWithNamespace(universal_provider_1.NameSpaceKeySui);
            if (senderAccounts.length == 0) {
                throw new universal_provider_1.OKXConnectError(universal_provider_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `there is no sui account`);
            }
            /// sender is required
            input.transactionBlock.setSender(senderAccounts[0]);
            const result = yield input.transactionBlock.build({
                client: this.suiClient,
            });
            const txBytes = (0, utils_1.toBase64)(result);
            const txSerialize = yield transactions_1.Transaction.from(txBytes).toJSON();
            resultTuple = [txBytes, txSerialize];
            return new Promise((resolve) => {
                resolve(resultTuple);
            });
        });
    }
}
exports.OKXSuiProvider = OKXSuiProvider;
exports.default = OKXSuiProvider;
